export const RESTRICTED_PAGES = [
    'product-details-page',
    'profile-page',
    'product-page',
    'post-details-page',
    'course-details',
    'course-details-page',
    'quiz-landing-page',
    'quiz-details-page',
    'quiz-results-page',
    'assignment-page',
    'lesson-video-player-page',
    'gradebook-page',
    'login-page',
    'wp-post-details'
];
